import { render, staticRenderFns } from "./SearchShipmentModal.vue?vue&type=template&id=6cd971d9"
import script from "./SearchShipmentModal.vue?vue&type=script&lang=js"
export * from "./SearchShipmentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports